import instanceAxios from '../config/api'

import {
  UpdateProfileRequest,
  UpdateProfileResponse,
  User,
} from '../types/userTypes'

const API_URL = '/auth'

export const getAllUsers = async () => {
  try {
    const response = await instanceAxios.get<{
      message: string
      users: User[]
    }>(`${API_URL}/users-by-client`)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch users.')
  }
}
export const activateUser = async (
  username: string
): Promise<{ message: string }> => {
  try {
    const response = await instanceAxios.put<{ message: string }>(
      `${API_URL}/activate/${username}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to activate user.')
  }
}
export const updateMyProfile = async (
  updateData: UpdateProfileRequest
): Promise<UpdateProfileResponse> => {
  try {
    const response = await instanceAxios.put<UpdateProfileResponse>(
      `${API_URL}/update-profile`,
      updateData
    )
    return response.data
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to update profile.'
    )
  }
}
